import { BRAND } from '../../constants'

export const ErrorMessage = () => <h3 style={{ color: BRAND.primaryColour }}>{' Loading Error '}</h3>